document.addEventListener('DOMContentLoaded', () => {
    // Initialize currency and locale data similar to bundle-item.js
    const currency = {
        country: window.cartStrings.country,
        symbol: window.cartStrings.currency_symbol,
        code: window.cartStrings.currency,
        lang: window.cartStrings.language,
    };

    const locale = window.internationalization.stores.filter(
        (store) => store.shopifyMarket === currency.country
    )[0];

    const language = locale?.languages.filter(
        (language) => language.lang === currency.lang
    )[0];

        // Format price using Shopify's exact money.liquid logic and internationalization rules
    const formatPrice = (price, showCurrencyCode = true) => {
        const priceInCents = Math.round(price * 100);
        
        // Get current store's currency settings from internationalization data
        const currentStore = window.internationalization?.stores?.find(
            store => store.shopifyMarket === currency.country
        );
        
        const currencySettings = currentStore?.currency || {
            showIsoCode: false,
            trailingZeros: false,
            prepend: ''
        };
        
        // Use Shopify's money formats from window.cartStrings (set in theme.liquid)
        const moneyFormat = showCurrencyCode ? 
            window.cartStrings.money_with_currency_format : 
            window.cartStrings.money_format;
        
        // Convert price to proper format
        let formatted = moneyFormat.replace('{{amount}}', (priceInCents / 100).toFixed(2));
        
        // Apply Shopify's exact money.liquid logic by country/currency
        if (currency.country === 'US' || currency.country === 'CA') {
            // US/CA: Use Intl.NumberFormat for consistency
            const locale = currency.country === 'CA' ? 'en-CA' : 'en-US';
            formatted = new Intl.NumberFormat(locale, {
                style: "currency",
                currency: currency.code,
                trailingZeroDisplay: currencySettings.trailingZeros
                    ? "auto"
                    : "stripIfInteger",
            }).format(priceInCents / 100);
        } else if (currency.country === 'SG') {
            // Singapore: Use Intl.NumberFormat with proper locale like bundle-item.js
            const money = new Intl.NumberFormat(language.code, {
                style: "currency",
                currency: currency.code,
                trailingZeroDisplay: currencySettings.trailingZeros
                    ? "auto"
                    : "stripIfInteger",
            }).format(priceInCents / 100);
            
            if (currencySettings.prepend === 'S') {
                formatted = money.replace('$', 'S$');
            } else {
                formatted = money;
            }
        } else if (currency.country === 'GB' || currency.country === 'AU') {
            // GB/AU: Use Intl.NumberFormat with proper locale (money_without_trailing_zeros)
            formatted = new Intl.NumberFormat(language.code, {
                style: "currency",
                currency: currency.code,
                trailingZeroDisplay: currencySettings.trailingZeros
                    ? "auto"
                    : "stripIfInteger",
            }).format(priceInCents / 100);
        } else if (currency.country === 'AE' || currency.country === 'KW' || currency.country === 'SA' || currency.country === 'QA' || currency.country === 'Qatar') {
            // GCC countries: UAE (AED), Kuwait (KWD), Saudi Arabia (SAR), Qatar (QAR)
            // Use English number formatting for consistency
            const baseFormatted = new Intl.NumberFormat('en', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 3,
                useGrouping: true
            }).format(priceInCents / 100);
            
            // Apply country-specific currency formatting
            if (currency.country === 'QA' || currency.country === 'Qatar') {
                // Qatar: QAR 17,526.25 (comma for thousands, period for decimals)
                formatted = `QAR ${baseFormatted}`;
            } else if (currency.country === 'KW') {
                // Kuwait: Dhs. 11,340
                formatted = `Dhs. ${baseFormatted}`;
            } else if (currency.country === 'SA') {
                // Saudi Arabia: 11,587 SR
                formatted = `${baseFormatted} SR`;
            } else if (currency.country === 'AE') {
                // United Arab Emirates: Dhs. 11,099
                formatted = `Dhs. ${baseFormatted}`;
            }
        } else if (currency.code === 'EUR') {
            // EUR: Replicate money.liquid logic exactly:
            // amount | money_without_trailing_zeros | remove: currency_symbol | replace: '.', ' ' | append: ' ' | append: currency_symbol
            
            // First, get the base amount without trailing zeros
            let baseAmount = (priceInCents / 100).toFixed(2).replace(/\.00$/, '');
            
            // Format with French locale for proper EUR formatting
            let eurAmount = parseFloat(baseAmount).toLocaleString('fr-FR', {
                minimumFractionDigits: baseAmount.includes('.') ? 2 : 0,
                maximumFractionDigits: 2
            });
            
            // Apply money.liquid transformations:
            // 1. Remove currency symbol (€)
            eurAmount = eurAmount.replace(/€/g, '');
            
            // 2. Replace dots with spaces for thousands separator
            eurAmount = eurAmount.replace(/\./g, ' ');
            
            // 3. Clean up spaces
            eurAmount = eurAmount.replace(/\s+/g, ' ').trim();
            
            // 4. Append space and currency symbol
            formatted = `${eurAmount} €`;
        } else {
            // Default: Use Shopify's money format and apply trailingZeros rule
            if (!currencySettings.trailingZeros) {
                formatted = formatted.replace(/\.00/, '');
            }
        }
        
        // Apply internationalization rules
        
        // Handle showIsoCode setting - only add/keep currency code if required
        // BUT skip this for GCC countries since they have custom formatting
        const isGccCountry = currency.country === 'AE' || currency.country === 'KW' || currency.country === 'SA' || currency.country === 'QA' || currency.country === 'Qatar';
        
        if (!isGccCountry) {
            if (showCurrencyCode && currencySettings.showIsoCode) {
                // Ensure currency code is present
                if (!formatted.includes(currency.code)) {
                    formatted = `${formatted} ${currency.code}`;
                }
            } else if (!showCurrencyCode || !currencySettings.showIsoCode) {
                // Remove currency code if present and not wanted
                const codeRegex = new RegExp(`\\s*${currency.code}\\s*`, 'g');
                formatted = formatted.replace(codeRegex, '').trim();
            }
        }
        
        // Apply prepend rule for non-Singapore countries (if any future ones need it)
        if (currencySettings.prepend && currencySettings.prepend !== '' && currency.country !== 'SG') {
            formatted = `${currencySettings.prepend}${formatted}`;
        }
        
        // Final cleanup: normalize whitespace
        formatted = formatted.replace(/\s+/g, ' ').trim();
        
        return formatted;
    };

    const updateVariantPrice = (subtotal) => {
        const subtotalElement = document.getElementById('Bundle-Savings-Subtotal');
        if (!subtotalElement) return;

        const stickyMenuSubtotal = document.querySelectorAll('.sticky-menu-subtotal');
        if (stickyMenuSubtotal.length > 0) {
            stickyMenuSubtotal.forEach((stickyItem) => {
                if (stickyItem) {
                    stickyItem.innerHTML = formatPrice(subtotal / 100, true);
                }
            });
        }

        // Update the data-amount attribute and innerHTML only if element exists
        if (subtotalElement) {
            subtotalElement.setAttribute('data-amount', subtotal);
            subtotalElement.innerHTML = formatPrice(subtotal / 100, true);
        }
    };

    const updateVariantDisplay = (selectedVariantId, parentVariantColor) => {
        // Show/Hide discount divs
        const discountDivs = document.querySelectorAll("[id^='discount-']");
        if (discountDivs.length > 0) {
            discountDivs.forEach((div) => {
                if (div) {
                    const variantId = div.getAttribute('data-variant-id');
                    if (variantId !== null) {
                        div.classList.toggle('hidden', variantId !== selectedVariantId);
                    }
                }
            });
        }

        // Show/Hide BundleItem Price
        const lineItemPrices = document.querySelectorAll('.line-item-price');
        if (lineItemPrices.length > 0) {
            lineItemPrices.forEach((item) => {
                if (item) {
                    const itemColor = item.getAttribute('data-line-item-color');
                    if (itemColor !== null) {
                        item.classList.toggle('hidden', itemColor !== parentVariantColor);
                    }
                }
            });
        }

        // Show/Hide Upsell Items
        const upsellItems = document.querySelectorAll('.upsell-bundle-item');
        if (upsellItems.length > 0) {
            upsellItems.forEach((item) => {
                if (item) {
                    const ignoreToggle = item.getAttribute('data-ignore-bcz-external-product') === 'true';
                    const itemColor = item.getAttribute('data-line-item-color');
                    
                    if (!ignoreToggle && itemColor !== null) {
                        item.classList.toggle('hidden', itemColor !== parentVariantColor);
                    }
                }
            });
        }
    };

    const updateEmiPrice = () => {
        const productSubtotalContainer = document.querySelector('#Bundle-Savings-Subtotal');
        if (!productSubtotalContainer) return;

        const getProductSubtotal = (container) => {
            const amount = container.getAttribute('data-amount');
            if (!amount) return 0;
            return (parseInt(amount, 10) / 100) / 24;
        };

        const productSubtotal = getProductSubtotal(productSubtotalContainer);
        if (productSubtotal === 0) return;
        
        const formattedProductSubtotal = formatPrice(productSubtotal);

        // Update EMI values only if elements exist
        const financingSectionDiv = document.querySelector('#financing-section-text__value');
        const productVariantLastEmiSpan = document.querySelector('.total-savings-emi-span');

        if (financingSectionDiv) {
            financingSectionDiv.innerHTML = formattedProductSubtotal;
        }
        
        if (productVariantLastEmiSpan) {
            productVariantLastEmiSpan.innerHTML = formattedProductSubtotal;
        }
    };

    const handleVariantButtonClick = (button) => {
        if (!button) return;

        const selectedVariantId = button.getAttribute('data-variant-id');
        const selectedVariantPrice = button.getAttribute('data-variant-price');
        const parentVariantColor = button.getAttribute('data-variant-color');

        // Only proceed if all required attributes are present
        if (!selectedVariantId || !selectedVariantPrice || !parentVariantColor) return;

        // Update the displayed price
        updateVariantPrice(selectedVariantPrice);

        // Update the displayed variant span
        updateVariantDisplay(selectedVariantId, parentVariantColor);

        // Update the emi prices
        updateEmiPrice();
    };

    // Event listener for variant buttons
    const variantButtons = document.querySelectorAll('.variant-button');
    if (variantButtons.length > 0) {
        variantButtons.forEach((button) => {
            if (button) {
                button.addEventListener('click', () => handleVariantButtonClick(button));
            }
        });
    }

    // Show the initially selected variant's price and span
    const initialButton = document.querySelector('.variant-button[data-initial="true"]');
    if (initialButton) {
        handleVariantButtonClick(initialButton);
    } else {
        // If no initial button found, still update EMI prices on page load
        updateEmiPrice();
    }
});